import React from "react";

type ZoomControlsProps = {
  currentItemNumber: number;
  totalItems: number;
  zoomLevel: number;
  onZoomOut?: () => void;
  onZoomIn?: () => void;
};

const ZoomControls: React.FC<ZoomControlsProps> = ({
  currentItemNumber,
  totalItems,
  zoomLevel,
  onZoomOut,
  onZoomIn,
}) => {
  return (
    <div className="flex items-center justify-center px-6">
      <div className="flex items-center gap-2 text-white">
        <span className="text-sm leading-5 min-w-[52px] text-center">
          {currentItemNumber} / {totalItems}
        </span>
        <span className="h-5 w-px bg-white" aria-hidden="true" />
        <button
          type="button"
          onClick={onZoomOut}
          className="px-1 focus:outline-none disabled:opacity-50"
          disabled={!onZoomOut}
          aria-label="Zoom out"
        >
          -
        </button>
        <span className="text-sm leading-5 min-w-[46px] text-center">
          {Math.round(zoomLevel)}%
        </span>
        <button
          type="button"
          onClick={onZoomIn}
          className="px-1 focus:outline-none disabled:opacity-50"
          disabled={!onZoomIn}
          aria-label="Zoom in"
        >
          +
        </button>
      </div>
    </div>
  );
};

export default ZoomControls;
